import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e3aa187")

_pushScopeId("data-v-0e3aa187")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Riepilogo richieste")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "search_container" }
const _hoisted_5 = {
  key: 0,
  class: "no_documents_container_detail"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "no_documents" }, "Nessuna richiesta da gestire", -1)
const _hoisted_7 = { class: "richieste_container" }
const _hoisted_8 = { class: "richiesta_info" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "note"
}
const _hoisted_17 = { class: "richiesta_actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadRichieste()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_ion_input, {
                    type: "text",
                    "clear-input": "",
                    modelValue: $setup.searchQuery,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.searchQuery = $event)),
                    placeholder: "Cerca richiesta",
                    class: "search_richieste_input"
                  }, null, 8, ["modelValue"])
                ]),
                ($setup.richiesteToShow.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.richiesteToShow, (richiesta) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "richiesta",
                      key: richiesta.richieste_id
                    }, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, _toDisplayString(richiesta.richieste_tipologia_value || richiesta.richieste_tipologia), 1),
                        _createVNode("div", _hoisted_10, _toDisplayString(richiesta.dipendenti_nome) + " " + _toDisplayString(richiesta.dipendenti_cognome), 1),
                        _createVNode("div", _hoisted_11, [
                          (richiesta.richieste_tipologia == '1')
                            ? (_openBlock(), _createBlock("span", _hoisted_12, [
                                _createTextVNode(_toDisplayString($setup.dateFormat(richiesta.richieste_dal)) + " ", 1),
                                (richiesta.richieste_ora_inizio && richiesta.richieste_ora_fine)
                                  ? (_openBlock(), _createBlock("span", _hoisted_13, " dalle " + _toDisplayString(richiesta.richieste_ora_inizio) + " alle " + _toDisplayString(richiesta.richieste_ora_fine), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_14, [
                                _createTextVNode(" Dal " + _toDisplayString($setup.dateFormat(richiesta.richieste_dal)) + " ", 1),
                                (richiesta.richieste_al)
                                  ? (_openBlock(), _createBlock("span", _hoisted_15, " al " + _toDisplayString($setup.dateFormat(richiesta.richieste_al)), 1))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        (richiesta.richieste_note)
                          ? (_openBlock(), _createBlock("div", _hoisted_16, " Note: " + _toDisplayString(richiesta.richieste_note), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_17, [
                        _createVNode("button", {
                          size: "small",
                          class: "btn_change_status btn_approve",
                          onClick: ($event: any) => ($setup.approveRichiesta(richiesta.richieste_id)),
                          disabled: $setup.processing
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: $setup.checkmark,
                            slot: "icon-only"
                          }, null, 8, ["icon"])
                        ], 8, ["onClick", "disabled"]),
                        _createVNode("button", {
                          size: "small",
                          class: "btn_change_status btn_decline",
                          onClick: ($event: any) => ($setup.rejectRichiesta(richiesta.richieste_id)),
                          disabled: $setup.processing
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: $setup.close,
                            slot: "icon-only"
                          }, null, 8, ["icon"])
                        ], 8, ["onClick", "disabled"])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})